import React, { useRef, useState } from 'react';
import { Button, Modal, Space, message, Input, Table } from 'antd';
import { ReloadOutlined, FolderOpenOutlined, PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import TableLoanAttr from './TableLoanAttr';
import FormLoanAttr from './FormLoanAttr';
import { OpenDialog, handleException, useHeighter, deleteRecord, waitRef } from './Utils';
import { hasRight } from './Login';

function ModuleLoanAttr({visible=true}) {
	const [tableHeight] = useHeighter(300);
	const dlgRef = useRef(null);
	const tableRef = useRef(null);
	const formRef = useRef(null);
	const writeRight = hasRight('loanattrs','W');		
	
	const handleRefresh = () => { 
		tableRef.current.refresh()	
	}	
	const handleAdd = () => {  
		dlgRef.current.open()
		waitRef(formRef).then(()=>{formRef.current.open(0,handleRefresh)})	
	};
	const handleOpen = (e) => {
		dlgRef.current.open()
		waitRef(formRef).then(()=>{ formRef.current.open(tableRef.current.getSelectedRecid(),handleRefresh) }) 
	};	
	const handleDelete = async () => { 
		await deleteRecord('/loanattrdelete',tableRef.current.getSelectedRecid())
		handleRefresh();		
	};
	
	return (
		<div style={{ display: visible?'block':'none'}}>
			<h1>Atributy půjček</h1>
			<div className="toolbar">
				<Space>
					<Button type="primary" icon={<ReloadOutlined/>} onClick={ handleRefresh} >Aktualizovat</Button>
					<Button icon={<FolderOpenOutlined/>} onClick={ handleOpen} >Otevřít</Button>
					<Button icon={<PlusOutlined/>} onClick={ handleAdd} disabled={!writeRight}>Přidat</Button>
					<Button icon={<DeleteOutlined/>} onClick={ handleDelete} disabled={!writeRight}>Odebrat</Button>
				</Space>
				<Input.Search className="toolbar-search"placeholder="Hledat..." onSearch={(value) => tableRef.current.setSearchInput(value)} />
        	</div>
			<TableLoanAttr ref={tableRef} doubleClicked={handleOpen} scroll={{ y: tableHeight }}/>
			<OpenDialog width={500} title="Atributy půjčky" Component={()=>(<FormLoanAttr writeRight={writeRight} ref={formRef}/>)} ref={dlgRef}/>
		</div>
	);
};

export default ModuleLoanAttr;

